import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'
import {
  permitTemplateKeys,
  RequestTypes,
} from '@core/react-query/features/templates/permitTemplates/permitTemplate'
import { projectsKeys } from '@core/react-query/features/projects'
import { RequestErrorType } from '@core/utils/api-axios-instance'

export const useAssignProjectsToTemplate = (
  options?: UseMutationOptions<
    unknown,
    RequestErrorType,
    RequestTypes['assignProjectsToTemplate']
  >,
) => {
  const queryClient = useQueryClient()
  return useMutation({
    ...permitTemplateKeys.assignProjectsToTemplate,
    ...options,
    onSuccess: () => {
      queryClient.invalidateQueries(projectsKeys._def)
    },
  })
}
